module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mu-snackbar"
    }
  }, [_c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.clickOutSide),
      expression: "clickOutSide"
    }],
    staticClass: "mu-snackbar",
    style: ({
      'z-index': _vm.zIndex
    })
  }, [_c('div', {
    staticClass: "mu-snackbar-message"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]), _vm._v(" "), (_vm.action) ? _c('flat-button', {
    staticClass: "mu-snackbar-action",
    attrs: {
      "color": _vm.actionColor,
      "rippleColor": "#FFF",
      "rippleOpacity": 0.3,
      "secondary": "",
      "label": _vm.action
    },
    on: {
      "click": _vm.handleActionClick
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a7a6529"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/snackbar/snackbar.vue
// module id = 440
// module chunks = 1